export var BodyTypeEnum;
(function(BodyTypeEnum) {
    BodyTypeEnum["Coupe"] = "COUPE";
    BodyTypeEnum["Estate"] = "ESTATE";
    BodyTypeEnum["Hatchback"] = "HATCHBACK";
    BodyTypeEnum["Saloon"] = "SALOON";
    BodyTypeEnum["Suv"] = "SUV";
})(BodyTypeEnum || (BodyTypeEnum = {}));
export var DriveTypeEnum;
(function(DriveTypeEnum) {
    DriveTypeEnum["FourWheelDrive"] = "Four-wheel drive";
    DriveTypeEnum["FrontWheelDrive"] = "Front-wheel drive";
    DriveTypeEnum["RearWheelDrive"] = "Rear-wheel drive";
})(DriveTypeEnum || (DriveTypeEnum = {}));
export var FuelTypeEnum;
(function(FuelTypeEnum) {
    FuelTypeEnum["Diesel"] = "Diesel";
    FuelTypeEnum["Electric"] = "Electric";
    FuelTypeEnum["Petrol"] = "Petrol";
    FuelTypeEnum["PetrolHybrid"] = "Petrol hybrid";
    FuelTypeEnum["PetrolPlugInHybrid"] = "Petrol plug-in hybrid";
})(FuelTypeEnum || (FuelTypeEnum = {}));
export var QuoteExcessMileage;
(function(QuoteExcessMileage) {
    QuoteExcessMileage["The2P"] = "2p";
    QuoteExcessMileage["The3P"] = "3p";
    QuoteExcessMileage["The4P"] = "4p";
})(QuoteExcessMileage || (QuoteExcessMileage = {}));
export var QuoteType;
(function(QuoteType) {
    QuoteType["HP"] = "hp";
    QuoteType["Pcp"] = "pcp";
})(QuoteType || (QuoteType = {}));
export var StockType;
(function(StockType) {
    StockType["Marketplace"] = "marketplace";
    StockType["PartnerSourced"] = "partner_sourced";
})(StockType || (StockType = {}));
export var TransmissionTypeEnum;
(function(TransmissionTypeEnum) {
    TransmissionTypeEnum["Automatic"] = "AUTOMATIC";
    TransmissionTypeEnum["Manual"] = "MANUAL";
})(TransmissionTypeEnum || (TransmissionTypeEnum = {}));
export var UpdatedBy;
(function(UpdatedBy) {
    UpdatedBy["FinanceQuoteComponentHPQuoteUpdated"] = "FinanceQuoteComponent.HPQuoteUpdated";
    UpdatedBy["FinanceQuoteComponentPCPQuoteUpdated"] = "FinanceQuoteComponent.PCPQuoteUpdated";
    UpdatedBy["MediaVehicleImageDataUpdated"] = "Media.vehicleImageDataUpdated";
    UpdatedBy["VehicleReservationsVehicleReserved"] = "VehicleReservations.VehicleReserved";
})(UpdatedBy || (UpdatedBy = {}));
